(() => {
  function init(root) {
    if (root.dataset.pcrReady) return;
    root.dataset.pcrReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-pcr-review]'));
    const all = root.querySelector('[data-pcr-all]');
    const photos = root.querySelector('[data-pcr-photos]');
    const clear = root.querySelector('[data-pcr-clear]');
    const ratings = Array.from(root.querySelectorAll('[data-pcr-rating]'));
    const status = root.querySelector('[data-pcr-status]');
    const empty = root.querySelector('[data-pcr-empty]');
    let rating = null, photosOnly = false;
    function apply() {
      let shown = 0;
      cards.forEach(card => {
        card.hidden = Boolean(rating && card.dataset.rating !== rating || photosOnly && card.dataset.hasPhotos !== 'true');
        if (!card.hidden) shown++;
      });
      ratings.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pcrRating === rating)));
      all?.setAttribute('aria-pressed', String(!rating && !photosOnly));
      photos?.setAttribute('aria-pressed', String(photosOnly));
      if (clear) clear.hidden = !rating && !photosOnly;
      if (status) status.textContent = (root.dataset.shown || '__COUNT__ shown').replace('__COUNT__', String(shown));
      if (empty) empty.hidden = shown > 0;
    }
    all?.addEventListener('click', () => { rating = null; photosOnly = false; apply(); });
    clear?.addEventListener('click', () => { rating = null; photosOnly = false; apply(); });
    ratings.forEach(button => button.addEventListener('click', () => { rating = rating === button.dataset.pcrRating ? null : button.dataset.pcrRating; apply(); }));
    photos?.addEventListener('click', () => { photosOnly = !photosOnly; apply(); });
    const photoCount = cards.filter(card => card.dataset.hasPhotos === 'true').length;
    const photoCountLabel = root.querySelector('[data-pcr-photo-count]');
    if (photoCountLabel) photoCountLabel.textContent = '(' + photoCount + ')';
    if (photos) photos.disabled = photoCount === 0;
    root.querySelectorAll('[data-pcr-expand]').forEach(button => button.addEventListener('click', () => {
      const body = button.closest('[data-pcr-review]')?.querySelector('[data-pcr-body]');
      if (!body) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      body.dataset.expanded = String(expanded);
      button.textContent = expanded ? root.dataset.collapse : root.dataset.expand;
    }));
    const dialog = root.querySelector('[data-pcr-dialog]');
    const image = dialog?.querySelector('[data-pcr-full-image]');
    const imageError = dialog?.querySelector('[data-pcr-image-error]');
    const previous = dialog?.querySelector('[data-pcr-prev]');
    const next = dialog?.querySelector('[data-pcr-next]');
    let group = [], index = 0, opener = null;
    function showPhoto() {
      const button = group[index];
      if (!button || !image) return;
      if (imageError) imageError.hidden = true;
      image.hidden = false;
      image.alt = button.getAttribute('aria-label') || '';
      image.src = button.dataset.pcrPhoto;
      const counter = dialog.querySelector('[data-pcr-counter]');
      if (counter) counter.textContent = `${index + 1} / ${group.length}`;
      if (previous) previous.disabled = group.length < 2;
      if (next) next.disabled = group.length < 2;
    }
    root.querySelectorAll('[data-pcr-photo]').forEach(button => button.addEventListener('click', () => {
      if (!dialog || !image || typeof dialog.showModal !== 'function') return;
      group = Array.from(button.closest('[data-pcr-review]').querySelectorAll('[data-pcr-photo]'));
      index = group.indexOf(button); opener = button; showPhoto();
      if (!dialog.open) dialog.showModal();
    }));
    previous?.addEventListener('click', () => { index = (index + group.length - 1) % group.length; showPhoto(); });
    next?.addEventListener('click', () => { index = (index + 1) % group.length; showPhoto(); });
    dialog?.querySelector('[data-pcr-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => { image?.removeAttribute('src'); opener?.focus({ preventScroll: true }); });
    dialog?.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog?.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); index = (index + (event.key === 'ArrowRight' ? 1 : group.length - 1)) % group.length; showPhoto(); } });
    if (image) image.addEventListener('error', () => { image.hidden = true; if (imageError) imageError.hidden = false; });
    if (cards.length) apply();
  }
  document.querySelectorAll('[data-pcr]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pcr]').forEach(init));
})();
